/* eslint-disable linebreak-style */
import assets from './images';

export const CAROUSELS = [
  {
    id: 'carousel-1',
    items: [
      { url: assets.img9, message: '' },
      { url: assets.img7, message: '' },
      { url: assets.img14, message: '' },
      { url: assets.img11, message: '' },
      { url: assets.img15, message: '' },
      { url: assets.img18, message: '' },
      { url: assets.img20, message: '' },
      { url: assets.img23, message: '' },
      { url: assets.img25, message: '' },
    ],
    number: 1,
    text: 'Temos como clientes renomadas empresas do ramo florestal e agricultores da região. Contamos com maquinários amplo para realização de diversos serviços. Sendo alguns deles: Construção, limpeza e reformas de açudes, construção de barragens, abertura e manuntenção de estradas florestais e rodiviárias, abertura e limpeza de valas, destoca e drenagem de terrenos.',
  },
  {
    id: 'carousel-2',
    items: [
      { url: assets.img26, message: '' },
      { url: assets.img27, message: '' },
      { url: assets.img28, message: '' },
      { url: assets.img31, message: '' },
      { url: assets.img29, message: '' },
      { url: assets.img34, message: '' },
      { url: assets.img35, message: '' },
      { url: assets.img36, message: '' },
      { url: assets.img1, message: '' },
    ],
    number: 2,
    text: 'Além de prestar serviços, também, alugamos nossas máquinas de alta qualidade para outras pessoas ou empresa. Solicite um orçamento: venha conhecer nossa empresa!',
  },
];

export const VIDEOS = [
  {
    id: 'video-1',
    item: assets.video1,
    number: 1,
  },
  {
    id: 'video-2',
    item: assets.video2,
    number: 2,
  },
];
